import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab__container" }

import { useRoute } from 'vue-router';
import { i18n } from '@/i18n';

//i18n

export default /*@__PURE__*/_defineComponent({
  __name: 'ControlViewTab',
  props: {
    nowView: {}
  },
  setup(__props: any) {

const t = i18n.t;
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(props.nowView === 'aggregateBusiness' ? 'tab__active' : 'tab__inactive'),
      onClick: _cache[0] || (_cache[0] = (e) => _ctx.$emit('click', 'aggregateBusiness'))
    }, _toDisplayString(_unref(t)('仕入取引')), 3),
    _createElementVNode("button", {
      class: _normalizeClass(props.nowView === 'business' ? 'tab__active' : 'tab__inactive'),
      onClick: _cache[1] || (_cache[1] = (e) => _ctx.$emit('click', 'business'))
    }, _toDisplayString(_unref(t)('販売取引')), 3)
  ]))
}
}

})